export default "__VITE_ASSET__8d19f25e__"